import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'data.email_template.advanced_editor',
  })

  return function onClick() {
    change(false)
  }
}
